import { createApp } from "vue";
import Minerve from "./Minerve";

/**
 * Monte une Minerve dans un élément du DOM, pour les endroits qui ne passent pas
 * par un gabarit Vue (étape du product tour Shepherd, par exemple).
 */
export function monterMinerve(
  props: Record<string, unknown>,
  element: HTMLElement = document.createElement("div")
): HTMLElement {
  createApp(Minerve, props).mount(element);
  return element;
}
